var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ResizableContent",
    {
      staticClass: "user-info-widget",
      class: { minimized: _vm.minimized },
      attrs: {
        handles: ["ml"],
        "on-resize": _vm.onResize,
        "max-width": _vm.maxUserInfoWidgetWidth,
        "min-width": _vm.minUserInfoWidgetWidth,
        width: _vm.cloneWidth,
      },
    },
    [
      _c(
        "div",
        { staticClass: "collapse-widget", on: { click: _vm.maximize } },
        [_c("div", { staticClass: "material-icons" }, [_vm._v("chevron_left")])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "user-info-head" }, [
        _c("div", { staticClass: "user-info-details" }, [
          _vm._v(_vm._s(_vm.$t("task.detail"))),
        ]),
        _vm._v(" "),
        _vm.minimized
          ? _c(
              "div",
              { staticClass: "material-icons", on: { click: _vm.maximize } },
              [_vm._v("add")]
            )
          : _c(
              "div",
              { staticClass: "material-icons", on: { click: _vm.minimize } },
              [_vm._v("close")]
            ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "user-info-wrapper" }, [
        _c(
          "div",
          { staticClass: "user-info-content" },
          [
            _vm.tab === "user-info"
              ? _c("ContactDetail", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "meta-referrals"
              ? _c("MetaReferrals", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "contact-properties"
              ? _c("ContactProperties", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "notes"
              ? _c("ContactNotes", { attrs: { "visitor-id": _vm.contact._id } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "ready-contents"
              ? _c("ReadyContents", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "agents"
              ? _c("AgentList", { attrs: { contact: _vm.contact } })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "user-info-menu" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "right-end" },
                  expression: "{ followCursor: true, placement: 'right-end' }",
                },
              ],
              staticClass: "user-info-menu-item",
              class: { selected: _vm.tab === "user-info" },
              attrs: {
                content: "Contact Details",
                content: _vm.$t("tour.popoverInfo"),
              },
              on: {
                click: function ($event) {
                  return _vm.changeTab("user-info")
                },
              },
            },
            [_c("UserInfoSvg")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "right-end" },
                  expression: "{ followCursor: true, placement: 'right-end' }",
                },
              ],
              staticClass: "user-info-menu-item",
              class: { selected: _vm.tab === "contact-properties" },
              attrs: {
                content: "Contact Properties",
                content: _vm.$t("message.contactProperties"),
              },
              on: {
                click: function ($event) {
                  return _vm.changeTab("contact-properties")
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons hash-icon",
                  staticStyle: { "font-size": "30px" },
                },
                [_vm._v("tag")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "right-end" },
                  expression: "{ followCursor: true, placement: 'right-end' }",
                },
              ],
              staticClass: "user-info-menu-item",
              class: { selected: _vm.tab === "meta-referrals" },
              attrs: { content: "Meta Referrals", content: "Meta Referrals" },
              on: {
                click: function ($event) {
                  return _vm.changeTab("meta-referrals")
                },
              },
            },
            [_c("MetaReferralsSVG")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "right-end" },
                  expression: "{ followCursor: true, placement: 'right-end' }",
                },
              ],
              staticClass: "user-info-menu-item",
              class: { selected: _vm.tab === "notes" },
              attrs: { content: "Notes", content: _vm.$t("message.notes") },
              on: {
                click: function ($event) {
                  return _vm.changeTab("notes")
                },
              },
            },
            [_c("NotesSvg")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "right-end" },
                  expression: "{ followCursor: true, placement: 'right-end' }",
                },
              ],
              staticClass: "user-info-menu-item",
              class: { selected: _vm.tab === "agents" },
              attrs: {
                content: "Agents",
                content: _vm.$t("message.agentDetails"),
              },
              on: {
                click: function ($event) {
                  return _vm.changeTab("agents")
                },
              },
            },
            [_c("AgentsSvg")],
            1
          ),
          _vm._v(" "),
          _vm.isLive && !_vm.isWatching()
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "right-end" },
                      expression:
                        "{ followCursor: true, placement: 'right-end' }",
                    },
                  ],
                  staticClass: "user-info-menu-item",
                  class: { selected: _vm.tab === "ready-contents" },
                  attrs: {
                    content: "Ready Contents",
                    content: _vm.$t("plans.readyContents"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeTab("ready-contents")
                    },
                  },
                },
                [_c("ReadyContentsSvg")],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }